import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import axios from "../api/baseurl";
import { useNavigate } from "react-router";

const AddPemeDetails = ({ isOpen, onRequestClose, onSave, userDetails }) => {
  const [loading, setLoading] = useState(false);
  const [isDocModalOpen, setIsDocModalOpen] = useState(false);
  const [gender, setGender] = useState([]);
  const [pemeDetails, setPemeDetails] = useState({
    id:Date.now().toString(),
    fullName: "",
    phoneNumber: "",
    gender: "",
    dob: "",
    companyId: "",
    email: "",
    address: "",
    pemeDocuments: [],
  });

   const navigate = useNavigate();
  useEffect(() => {
    if (userDetails) {
      setPemeDetails({
        id:userDetails.id || Date.now().toString(),
        fullName: userDetails.fullName || "",
        phoneNumber: userDetails.phoneNumber || "",
        gender: userDetails.gender || "",
        dob: userDetails.dob || "",
        companyId: userDetails.companyId || "",
        email: userDetails.email || "",
        address: userDetails.address || "",
        pemeDocuments: userDetails.pemeDocuments || [],
      });
    }
  }, [userDetails]);

  function getBase64FromFile(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const [metadata, content] = reader.result.split(",");
        resolve({ 
          file: content,  // Base64 content
          fileContentType: metadata, // MIME type
          fileSize: file.size,
          fileName:file.name
        });
      };
      reader.onerror = (error) => reject(error);
    });
  }
  
  const [selectedFiles, setSelectedFiles] = useState([]);

  const handleFileChange = async (e) => {
    const files = Array.from(e.target.files); // Convert FileList to an array
    if (!files.length) return;
  
    const base64Files = await Promise.all(files.map(file => getBase64FromFile(file))); // Convert each file to Base64
  
    setSelectedFiles((prevFiles) => [...prevFiles, ...base64Files]); // Append new files to existing ones
  };
  
 const handleAddDocument = () => {
  if (!selectedFiles.length) return; // Ensure files exist before adding

  setPemeDetails((prevState) => ({
    ...prevState,
    pemeDocuments: [...prevState.pemeDocuments, ...selectedFiles], // Spread files correctly
  }));


  setSelectedFiles([]); // Clear selected files
  setIsDocModalOpen(false);
};

useEffect(() => {
    const fetchData = async () => {
      try {
        const token = JSON.parse(localStorage.getItem("data")).token;
    
        const gender = await axios.get(`/api/gender`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setGender(gender.data);
       
      } catch (error) {
        handleError(error);
      }
    };
    fetchData();
  }, []);

  function handleError(error) {
      if (error.response) {
        if (error.response.status === 401) {
          navigate(`/signin`);
          toast.error("Your session has expired. Please login.");
        } else if (error.response.data && error.response.data.message) {
          toast.error(error.response.data.message);
        }  else if (error.response.data && error.response.data.code) {
          toast.error(error.response.data.code);
        }
         else {
          toast.error("An error occurred.");
        }
      } else if (error.message) {
        toast.error(error.message);
      } else {
        toast.error("An error occurred.");
      }
    }
  
  

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setPemeDetails((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };
  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    if (userDetails && userDetails.id) {
      // If userDetails is an object, update it directly
      onSave({ ...userDetails, ...pemeDetails });
    } else {
      // If adding a new user (assuming it should replace existing details)
      onSave(pemeDetails);
      
    }
  
    onRequestClose();
    setLoading(false);
  };
  
  
  const handleRemoveDocument = (index) => {
    setPemeDetails((prevState) => ({
      ...prevState,
      pemeDocuments: prevState.pemeDocuments.filter((_, i) => i !== index),
    }));
  };

  const handleViewDocument = (doc) => {
    if (!doc || !doc.file) return;
  
    // Convert Base64 to Blob
    const byteCharacters = atob(doc.file);
    const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    
    const fileType = doc.fileContentType.split(":")[1].split(";")[0]; // Extract file type from metadata
    const blob = new Blob([byteArray], { type: fileType });
    const fileURL = URL.createObjectURL(blob);
  
    // Open the file in a new tab
    window.open(fileURL, "_blank");
  };
  
  return (
    <>
      <Modal show={isOpen} onHide={onRequestClose} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Add Users</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading && <div className="loading"></div>}
          <form onSubmit={handleSave}>
            <div className="row">
              <div className="col-md-6 mb-2">
                <label>
                  Full Name <span style={{ color: "maroon" }}>(Required)</span>
                </label>
                <input
                  className="form-control"
                  id="fullName"
                  type="text"
                  value={pemeDetails.fullName}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="col-md-6 mb-2">
                <label>
                  Email <span style={{ color: "maroon" }}>(Required)</span>
                </label>
                <input
                  className="form-control"
                  id="email"
                  type="email"
                  value={pemeDetails.email}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-4 mb-2">
                <label>
                  Phone Number <span style={{ color: "maroon" }}>(Required)</span>
                </label>
                <input
                  className="form-control"
                  id="phoneNumber"
                  type="text"
                  value={pemeDetails.phoneNumber}
                  onChange={handleInputChange}
                  required
                />
              </div>

                <div className="col-md-4 mb-2">
                <label>
                  DOB <span style={{ color: "maroon" }}>(Required)</span>
                </label>
                <input
                  className="form-control"
                  id="dob"
                  type="date"
                  value={pemeDetails.dob}
                  onChange={handleInputChange}
                  required
                />
              </div>
               <div className="col-md-4 mb-2">
                    <label htmlFor="gender">
                      Gender <span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      className="form-select"
                      id="gender"
                      value={pemeDetails.gender}
                        onChange={handleInputChange}
                      required
                    >
                      <option value="">Select Gender</option>
                      {gender.map((cat) => (
                        <option key={cat.id} value={cat.gender}>
                          {cat.gender}
                        </option>
                      ))}
                    </select>
   
                </div>
            </div>

            <div className="d-flex align-items-center justify-content-between mt-4">
              <h5>Documents:</h5>
              <Button variant="success" onClick={() => setIsDocModalOpen(true)}>
                <FontAwesomeIcon icon={faPlus} />
              </Button>
            </div>

            <br />
            <table className="table table-bordered">
              <thead>
                <tr className="table-header">
                  <th>Sl.No.</th>
                  <th>File Name</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {pemeDetails.pemeDocuments.length === 0 ? (
                  <tr>
                    <td colSpan="3" className="text-center">
                      No Data Available
                    </td>
                  </tr>
                ) : (
                  pemeDetails.pemeDocuments.map((doc, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{doc.fileName}</td>
                      <td>
                        <div className="d-flex align-items-center gap-2">
                        <Button variant="info" size="sm" onClick={() => handleViewDocument(doc)}>
  <FontAwesomeIcon icon={faEye} />
</Button>

                          <Button
                            variant="danger"
                            size="sm"
                            onClick={() => handleRemoveDocument(index)}
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>

            <Button type="submit" variant="primary" disabled={loading}>
              SAVE
            </Button>
            <Button variant="secondary" onClick={onRequestClose} className="ms-2">
              Close
            </Button>
          </form>
        </Modal.Body>
      </Modal>

      <Modal show={isDocModalOpen} onHide={() => setIsDocModalOpen(false)} centered>
  <Modal.Header closeButton>
    <Modal.Title>Add Documents</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <input 
      type="file" 
      className="form-control" 
      onChange={handleFileChange} 
      multiple 
    />
    <ul>
      {selectedFiles.map((file, index) => (
        <li key={index}>{file.fileName}</li>
      ))}
    </ul>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="primary" onClick={handleAddDocument}>
      Save
    </Button>
    <Button variant="secondary" onClick={() => setIsDocModalOpen(false)} className="ms-2">
      Close
    </Button>
  </Modal.Footer>
</Modal>


    </>
  );
};

export default AddPemeDetails;
